import { Injectable } from '@angular/core';
import { UbicarComponent } from './ubicar/ubicar.component';
import { ICoordenadas } from 'modelos/src';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class UbicarService {
  constructor(private matDialog: MatDialog) {}

  public async ubicar(
    coordenadas: ICoordenadas,
    title?: string,
    markerDraggable = false,
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const config: MatDialogConfig = {
          data: {
            coordenadas,
            title,
            markerDraggable,
          },
          width: '500px',
          maxWidth: '90%',
          panelClass: 'dialog-no-padding',
          disableClose: true,
        };
        const modal = this.matDialog.open(UbicarComponent, config);
        modal.afterClosed().subscribe((result) => {
          resolve(result);
        });
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  }
}
